<script>
import {defineComponent} from 'vue'
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import {Link} from "@inertiajs/vue3";

export default defineComponent({
    name: "PopularProductBannerItem",
    props: {
        img: {
            required: true,
        },
        title: {
            required: true,
            type: String,
        },
        description: {
            required: true,
            type: String,
        },
        link: {
            required: true,
            type: String,
        }
    },
    components: {Link, IconAngleLeft}
})
</script>

<template>
    <Link :href="link" class="group relative rounded-3xl overflow-hidden shadow-lg">
        <img :src="img" :alt="title" :title="title"
             class="w-full h-64 object-bottom object-cover md:group-hover:scale-110 transition-transform duration-500">
        <div class="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-6">
            <div class="flex items-end justify-between gap-5">
                <div class="text-white">
                    <h2 class="text-lg font-bold mb-1 uppercase">
                        {{ title }}
                    </h2>
                    <p class="text-sm">
                        {{ description }}
                    </p>
                </div>
                <div
                    class="min-w-10 min-h-10 max-w-10 max-h-10 bg-white md:group-hover:bg-baseColor text-black md:group-hover:text-black rounded-full flex items-center justify-center transition">
                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                </div>
            </div>
        </div>
    </Link>
</template>

<style scoped lang="scss">

</style>
